module.exports = __webpack_public_path__ + "img/5.荣誉资质.09ebca65.jpg";